// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"40":"debug","176":"charts","178":"audios","456":"slideshows","463":"videos"}[chunkId] + ".chunk.advanced_v12.js?v=12.1.14";
};